export const environment = {
  apiGatewayConfig: {
    apiGatewayUrl: 'https://api-gateway-staging.drcedirect.com/',
    apiGatewayCloudUrl: 'https://api-gateway-cloud-staging.drcedirect.com',
    client: 'all',
    deployment: 'staging',
    version: 'v0',
    enableCache: true,
    dynatraceConfig: {
      scriptUrl: 'https://js-cdn.dynatrace.com/jstag/17b628055ae/bf63792rhe/ae96b177313ebd8e_complete.js'
    }
  },
  production: true,
  okta: {
    clientConfig: {
      issuer: 'https://auth-stg.drcedirect.com/oauth2/default',
      clientId: 'eca-portal',
      redirectUri: 'https://cdn-app-staging.drcedirect.com',
      pkce: true,
      tokenManager: {
        secure: true,
        storage: 'sessionStorage'
      }
    },
    samlRedirectUrl: 'https://auth-stg.drcedirect.com/app/datarecognitioncorpstg_ecainsightportal_1/exkivblpX419N3e3w1d5/sso/saml'
  },
  islandBrowserUrl: '',
  userManagementUrl: 'https://stg.uum-le.drcedirect.com',
  serviceNowUrl: 'https://datarecognitioncorpqa.service-now.com/customerserviceportal2?id=csp2_connect_chat',
  genesys: {
    deploymentId: '37a742bf-b5a0-47af-b552-d211ab3d8a44',
    environment: 'usw2',
    orgGuid: '4e8196cb-bd36-4309-9008-eea81adb60b3',
    script: 'https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js'
  },
  confluenceUrl: 'https://eps-stg.awcl.drcedirect-le.com/api/v1/docs',
  useNewLoginPage: false
};
